// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__2If8H","imgNav":"Navbar_imgNav__qes0J","navText":"Navbar_navText__fGTUT","imgLogo":"Navbar_imgLogo__2wB8z","imgLogo_2":"Navbar_imgLogo_2__3Kr6L"};